module.exports = __webpack_public_path__ + "static/img/brand_logo.43c4923.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand_logo.png
// module id = ENQi
// module chunks = 0